interface ArtworkMetadataProps {
	currentChapter: { text: string } | null;
	activeChapterIndex: number;
	totalChapters: number;
	podcastTitle?: string;
}

/**
 * ArtworkMetadata Component
 * TODO: Replace with actual artwork and metadat, load dynamically from the chapter
 *
 * Displays podcast artwork and metadata including:
 * - Podcast artwork (placeholder)
 * - Current chapter title
 * - Podcast title
 * - Chapter progress indicator
 */
export function ArtworkMetadata({
	currentChapter,
	podcastTitle,
}: ArtworkMetadataProps) {
	return (
		<div className="flex w-64 items-center gap-4">
			{/* Artwork placeholder */}
			{/* <div className="h-16 w-16 shrink-0 rounded-xl bg-gradient-to-br from-primary/20 to-primary/40 flex items-center justify-center shadow-md">
				<svg
					className="h-8 w-8 text-primary"
					fill="currentColor"
					viewBox="0 0 24 24"
					aria-label="Podcast artwork"
				>
					<title>Podcast Artwork</title>
					<path d="M12 2L2 7L12 12L22 7L12 2Z" />
					<path d="M2 17L12 22L22 17" />
					<path d="M2 12L12 17L22 12" />
				</svg>
			</div> */}

			{/* Metadata */}
			<div className="flex-1 min-w-0">
				<p className="text-sm font-medium text-white truncate">
					{currentChapter?.text || null}
				</p>
				<p className="text-xs text-gray-400 truncate">{podcastTitle || null}</p>
			</div>
		</div>
	);
}
